<template>
  <div class="row column-s jobsClient">
    <div
      class="cards column grid-12-s"
      :class="openMap ? 'grid-5 opened' : 'grid-11-g grid-11-m grid-12-s'"
    >
      <div class="row wrap-m wrap-s align-end">
        <div class="title grid-4-g grid-12 row">
          <div class="grid-10 grid-11-m grid-11-s">
            <b>Dashboard</b>
            <br v-if="openMap" />
            <span>( {{ jobsFilter.length }} Jobs )</span>
          </div>
          <div class="filters-mobile hide-g" @click="filters = !filters">
            <i class="fa fa-filter"></i>
          </div>
        </div>

        <div
          :class="filters ? '' : 'hide-m hide-s'"
          class="row filters column-s grid-12-s grid-8-g grid-12-m justify-end"
        >
          <div class="search fa">
            <input type="text" placeholder="Buscar" v-model="search" />
          </div>
          <div class="date">
            <input
              type="date"
              placeholder="Data início"
              v-model="date.start"
              @keyup.13="loadJobs"
              @change="loadJobs"
            />
            <input
              type="date"
              placeholder="Data fim"
              v-model="date.end"
              @keyup.13="loadJobs"
              @change="loadJobs"
            />
          </div>
          <div class="list hide-s">
            <i
              class="fa fa-th-large"
              :class="showCards ? 'active' : ''"
              @click="showCards = true"
            ></i>
            <i
              class="fa fa-list"
              :class="showCards ? '' : 'active'"
              @click="showCards = false"
            ></i>
          </div>
        </div>
      </div>
      <!-- STEPS -->

      <div class="content row wrap grid-11-s" v-if="!loader" @scroll="scrolled">
        <template v-if="showCards">
          <Card
            v-for="(job, index) in jobsFilter"
            :key="'card' + index"
            :job="job"
            :remote="job.forma_atendimento == 'remoto' ? true : false"
            :map="() => openMarker({ lat: job.latitude, lng: job.longitude }, job)"
          />
        </template>
        <Table v-else :jobs="jobsFilter" :pager="pager" />
        <div
          v-if="!jobsFilter.length && !loader"
          class="jobs-empty grid-12 column align-center justify-center"
        >
          <img src="../../assets/img/error.svg" alt="erro" />
          <div class="jobs-empty-text text-center">
            <br />
            <strong>Nenhum</strong>
            <br />Job encontrado
          </div>
        </div>
      </div>
      <div v-else class="cards-loader column align-center justify-center">
        <Loader />
      </div>
    </div>
    <div v-if="showMap" class="map" :class="openMap ? 'grid-7' : 'grid-1'">
      <div
        class="openMap hide-s"
        @click="
          openMap = !openMap;
          !openMap ? (card.show = false) : false;
        "
      >
        <i class="fa fa-chevron-left" v-if="!openMap"></i>
        &nbsp;
        {{ openMap ? "Fechar" : "Mapa" }} &nbsp;
        <i class="fa fa-chevron-right" v-if="openMap"></i>
      </div>
      <div
        class="openMap mobile"
        @click="
          showMap = false;
          card.show = false;
        "
      >
        &nbsp; Fechar &nbsp;
        <i class="fa fa-close"></i>
      </div>
      <gmap-map :center="center" :zoom="zoom" @click="openMap = true">
        <gmap-marker
          v-for="(j, index) in jobsFilter"
          :position="{ lat: j.latitude, lng: j.longitude }"
          @click="() => openMarker({ lat: j.latitude, lng: j.longitude }, j, true)"
          :draggable="false"
          :key="index"
        ></gmap-marker>
      </gmap-map>
    </div>

    <!--  CARD DO MAPA -->
    <Card
      class="card-map"
      :job="card.job"
      :class="card.show ? 'active' : ''"
      :map="false"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import Loader from "@/components/Loader";
import Card from "@/components/Card.vue";
import Table from "@/components/TableJobs.vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBb14nrVdCZh_uBI-wGkjjmB0ypHS4YInY",
  },
});

export default {
  name: "JobsClientView",
  components: {
    Card,
    Loader,
    Table,
  },
  data() {
    return {
      pager: 18,
      openMap: false,
      filters: false,
      loader: true,
      showMap: window.innerWidth > 850 ? true : false,
      date: {
        start: new Date(),
        end: new Date().toISOString().slice(0, 10),
      },
      showCards: true,
      search: "",
      filter: {
        0: true,
      },
      card: { job: {}, x: "0px", y: "0px", show: false },
      center: { lat: -15.0575488, lng: -54.247716 },
      zoom: 5,
    };
  },
  methods: {
    ...mapActions("jobs", ["LOAD_JOBS"]),

    loadJobs() {
      if (this.date.start !== "" && this.date.end !== "") {
        this.loader = true;
        this.LOAD_JOBS({
          data_inicio: this.date.start,
          data_fim: this.date.end,
        }).then(() => (this.loader = false));
      }
    },
    openMarker(marker, job, card) {
      this.card.show = false;
      this.center = marker;
      this.card.job = job;
      if (this.openMap && card && this.zoom == 14) {
        /*         let offY = job.id_doutor ? 100 : 400;
        this.card.x =
          (event.pageX || event.changedTouches[0].pageX) - 210 + "px";
        this.card.y =
          (event.pageY || event.changedTouches[0].pageY) - 400 + "px"; */
        this.card.show = true;
      }
      this.zoom = 14;
      this.openMap = true;
      this.showMap = true;
    },

    changeFilter(index, search) {
      this.search = search;
      this.filter = { [index]: true };
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    scrolled(event) {
      if (
        event.target.offsetHeight + event.target.scrollTop ==
        event.target.scrollHeight
      ) {
        this.pager += 9;
      }
    },
  },
  beforeMount() {
    this.date.start = new Date();
    this.date.end = new Date();
    this.date.end.setDate(this.date.start.getDate() + 7);
    /* 
    if (this.date.end < this.date.start)
      this.date.end.setMonth(this.date.end.getMonth() + 1); */

    this.date.start.setDate(this.date.start.getDate() - 14);

    this.date.start = this.date.start.toISOString().slice(0, 10);
    this.date.end = this.date.end.toISOString().slice(0, 10);
    this.loadJobs();
  },
  computed: {
    ...mapGetters("jobs", ["jobs"]),
    jobsFilter() {
      if (this.search) {
        const search = this.search.toLowerCase();

        return this.jobs.filter((job) => {
          const jobSerialize = JSON.stringify(job).toLowerCase();

          /*          if (this.date.start && this.date.end) {
            let start = new Date(this.date.start);
            start.setHours(0, 0, 0, 0);
            start.setDate(start.getDate() + 1);

            let end = new Date(this.date.end);
            end.setHours(24, 0, 0, 0);
            end.setDate(end.getDate() + 1);
            this.loader = false;
            return (
              new Date(job.dh_agendamento_cliente) >= start &&
              new Date(job.dh_agendamento_cliente) <= end &&
              jobSerialize.includes(search)
            );
          } else { */

          return jobSerialize.includes(search);
          /* } */
        });
      } else {
        let pager = [];
        this.jobs.map((j, i) => {
          if (i < this.pager) pager.push(j);
        });
        return pager;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.jobsClient {
  height: 92.5vh;
  .cards {
    background: $white-2;
    overflow: auto;
    @media (min-width: $small) {
      border-right: 2px solid $white-1;
    }
    .title {
      letter-spacing: -0.26px;
      color: $purple;
      font-size: 30px;
      span {
        color: $gray-9;
        font-weight: bold;
        margin-left: 5px;
        font-size: 16px;
      }
      @media (min-width: $small) {
        padding-left: 70px;
        padding-top: 50px;
      }
      @media (max-width: $small) {
        padding: 30px 20px;
      }
    }
    input {
      border: none;
      padding: 5px 7px;
      font-size: 13px;
      color: $gray-1;
      background: $white-2;
      &:focus {
        outline: none;
      }
    }
    .date {
      input {
        width: 130px;
        @media (max-width: $small) {
          width: 45%;
        }
      }
      border-bottom: 1px solid $white-4;
      margin-right: 30px;
      height: 35px;
      padding-right: 20px;
      &:after {
        content: url("../../assets/img/calendar.svg");
        margin-top: 20px;
        position: absolute;
      }
    }
    .search {
      margin-right: 20px;
      padding-right: 20px;
      height: 35px;
      border-bottom: 1px solid $white-4;
      @media (max-width: $small) {
        margin-bottom: 25px;
        margin-right: 30px;
      }

      input {
        border: none;
        padding: 5px 7px;
        @media (max-width: $small) {
          width: 92%;
        }
      }

      &:after {
        content: "\f002";
        color: $white-4;
        position: absolute;
        margin-left: 0px;
        margin-top: 20px;
      }
    }
    .list {
      margin-right: 50px;
      i {
        color: $gray-9;
        width: 35px;
        height: 35px;
        border-radius: 4px;
        text-align: center;
        line-height: 38px;
        font-size: 25px;
        margin-right: 7px;
        &:hover {
          cursor: pointer;
          background: $green-2;
          color: $white;
          opacity: 0.7;
        }
      }
      .active {
        background: $white-1;
        color: $white;
      }
    }
    .status {
      margin-top: 50px;
      font-size: 15px;
      color: $gray-10;
      padding-right: 65px;
      border-bottom: 1px solid $white-1;
      padding-left: 70px;
      min-width: 800px;

      @media (max-width: $small) {
        padding-left: 25px;
        margin-top: 25px;
      }
      &-mask {
        overflow: auto;
        height: 200px;
      }
      &-container {
        overflow: hidden;
        height: 150px;
      }

      li {
        padding-bottom: 10px;
        cursor: pointer;
        &:hover {
          color: $green-1;
          border-bottom: 3px solid $green-1;
        }
      }
      .active {
        color: $green-10;
        border-bottom: 3px solid $green-10;
      }
    }

    &-loader {
      margin-top: 15%;
    }

    .content {
      padding-left: 70px;
      padding-top: 0px;
      padding-bottom: 10%;
      overflow: auto;
      margin-right: 50px;
      margin-top: 25px;
      max-height: 600px;
      overflow-y: auto;
      @media (max-width: $small) {
        height: 100vh;
        padding-left: 20px;
        margin-top: 10px;
        padding-top: 0px;
      }
    }
  }
  .vue-map-container {
    width: 100%;
    height: 100%;
  }
  .openMap {
    background: $white-2 0% 0% no-repeat padding-box;
    border: 2px solid $white-1;
    border-left: none;
    border-radius: 0px 17px 17px 0px;
    font-size: 15px;
    color: $gray-2;
    width: 90px;
    cursor: pointer;
    position: absolute;
    bottom: 50px;
    z-index: 791;
    padding: 12px 15px;
    font-weight: bold;
    &.mobile {
      display: none;
      background: $gray-1 0% 0% no-repeat padding-box;
      color: $white;
      @media (max-width: $small) {
        display: block;
        position: fixed;
        bottom: 50px;
      }
    }
  }
  .filters {
    input {
      color: $gray-5;
      font-weight: bold;
    }
    @media (max-width: $small) {
      padding-top: 0px;
      padding-left: 20px;
      margin-bottom: 25px;
    }
    @media (max-width: $large) {
      margin-top: 30px;
    }
  }
  .filters-mobile {
    i {
      border-radius: 50%;
      color: $gray-2;
      width: 45px;
      height: 45px;
      text-align: center;
      line-height: 46px;
    }
  }

  .opened {
    .card {
      width: 100%;
    }

    .status {
      &-container {
        height: 170px;
      }
    }
    .filters {
      @media (min-width: $small) {
        margin-top: 30px;
        width: 100%;
        margin-left: 70px;
        flex-direction: column;

        margin-left: 70px;
        .search,
        .date,
        .list {
          margin-top: 20px;
        }
        .search input {
          width: 90%;
        }
        .date input {
          width: 45%;
        }
      }
    }
    .content {
      margin-right: 0px;
    }
  }

  .card-map {
    position: fixed;
    width: 327px;
    right: 17%;
    bottom: -400px;
    &.active {
      bottom: 0px;
      right: 17%;
      @media (max-width: $small) {
        left: 2%;
        bottom: 120px;
      }
    }
  }
  .map {
    @media (max-width: $small) {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0px;
    }
  }
}
</style>
